import { render, staticRenderFns } from "./InterconsultasPage.vue?vue&type=template&id=0269dc72"
import script from "./InterconsultasPage.vue?vue&type=script&lang=js"
export * from "./InterconsultasPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports